(() => {
  function isMothersDaySeason(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const year = Number(values.year);
    const today = Date.UTC(year, Number(values.month) - 1, Number(values.day));
    const weekday = new Date(Date.UTC(year, 4, 1)).getUTCDay();
    const holiday = Date.UTC(year, 4, 8 + (7 - weekday) % 7);
    return today >= holiday - 14 * 86400000 && today <= holiday;
  }
  function updateSeason() {
    const active = isMothersDaySeason();
    document.querySelectorAll('[data-vb-mothers-day]').forEach(element => {
      element.hidden = !active;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSeason, { once: true });
  } else {
    updateSeason();
  }
  document.addEventListener('shopify:section:load', updateSeason);
  window.addEventListener('pageshow', updateSeason);
  setInterval(updateSeason, 60000);
})();
